import React from "react";

export default function ChevronDown() {
  return (
    <svg
      width="32px"
      height="16px"
      viewBox="0 0 28 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Welcome"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="chevron-down"
          transform="translate(-912.000000, -417.000000)"
          fill="#131313"
          fillRule="nonzero"
        >
          <g
            id="noun_chevron_1703104"
            transform="translate(912.000000, 417.000000)"
          >
            <g id="Group" transform="translate(0.000000, 0.318910)">
              <polygon
                id="Shape"
                points="13.999975 15.267 15.328125 14.11075 27.828125 3.11075 25.171875 0.09515 13.999975 9.92325 2.828125 0.09515 0.171875 3.11075 12.671875 14.11075"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
